import Banner from 'components/Banner';
import React from 'react';
import AdditionalPageContent from './PageContent';

const AdditionalPage = ({ title, background, buttonText, pageContentData }) => {
    return (
        <>
            <Banner title={title} image={background} buttonText={buttonText} />
            <AdditionalPageContent pageContentData={pageContentData} />
        </>
    );
};

export default AdditionalPage;
